import { createContext, type PropsWithChildren } from "react";
import type { TranslateFn, TranslationKey, Translations } from "@/features/translations/types";
import useInitializedContext from "@/hooks/use-initialized-context.ts";
import type { LooseAutocomplete, Nullable, Nullish } from "@/types";
import { replaceStringVars } from "@/utils/text.ts";

type TranslationsContextType = {
    translations: Translations;
    t: TranslateFn;
};

const TranslationsContext = createContext<Nullable<TranslationsContextType>>(null);

export const useTranslationsContext = () => useInitializedContext(TranslationsContext, "Translations");
export const useTranslations = () => useTranslationsContext().t;

type Props = PropsWithChildren<{ translations: Translations }>;
export default function Translations({ children, translations }: Props) {
    const t = (key: LooseAutocomplete<TranslationKey>, vars?: Record<string, Nullish<string | number>>) => {
        const label = translations[key as TranslationKey] ?? key;

        return replaceStringVars(label, vars ?? {});
    };

    return <TranslationsContext value={{ translations, t }}>{children}</TranslationsContext>;
}
